import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'placeholder-key';

if (!process.env.REACT_APP_SUPABASE_URL || !process.env.REACT_APP_SUPABASE_ANON_KEY) {
  // eslint-disable-next-line no-console
  console.warn('Missing Supabase environment variables. Using placeholder values.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// Database Types
export interface Profile {
  id: string;
  email: string;
  first_name: string | null;
  last_name: string | null;
  username: string | null;
  profile_color: string | null;
  subscription_tier: 'free' | 'elite';
  is_subscribed: boolean;
  subscription_start_date: string | null;
  subscription_end_date: string | null;
  created_at: string;
  updated_at: string;
}

export interface NewsletterSubscriber {
  id: string;
  email: string;
  subscribed_at: string;
  is_active: boolean;
  source: string;
  user_id: string | null;
}

export interface GameSession {
  id: string;
  user_id: string;
  game_type: 'math_challenge' | 'sum_grid';
  difficulty: 'easy' | 'medium' | 'hard' | null;
  score: number | null;
  completed: boolean;
  completion_time_seconds: number | null;
  hints_used: number;
  started_at: string;
  completed_at: string | null;
  session_data: Record<string, any> | null;
}

export interface DailyStreak {
  id: string;
  user_id: string;
  game_type: 'math_challenge' | 'sum_grid';
  current_streak: number;
  longest_streak: number;
  last_play_date: string | null;
  created_at: string;
  updated_at: string;
}